import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "../components/AuthShell";
import { useContent } from "../lib/content";
import CheckEmail from "../components/CheckEmail";
import { api, errMsg } from "../lib/api";

export default function Registro() {
  const { t } = useContent();
  const { state } = useLocation();
  const [form, setForm] = useState({ name: state?.name || "", email: state?.email || "", password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [sentTo, setSentTo] = useState(null);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { toast.error("Las contraseñas no coinciden"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", {
        name: form.name, email: form.email, password: form.password, birth: state?.birth || null,
      });
      setSentTo(data.email);
    } catch (err) { toast.error(errMsg(err, "No se pudo crear la cuenta")); }
    finally { setLoading(false); }
  };

  if (sentTo) return <CheckEmail email={sentTo} />;

  return (
    <AuthShell testid="registro-page" overline="Crear cuenta" title={t("plat_register_title")}>
      {state?.birth && (
        <p data-testid="registro-birth-note" className="mb-6 p-4 border border-[#C9A25E]/25 bg-[#C9A25E]/5 text-sm text-zinc-300">
          ✦ Guardaremos tu carta natal ({state.birth.birth_date} · {state.birth.birth_time} · {state.birth.birth_place}).
        </p>
      )}
      <form onSubmit={submit} data-testid="registro-form" className="space-y-5">
        <div><label className="field-label">Nombre</label>
          <input data-testid="registro-name" required className="input-field" value={form.name} onChange={set("name")} /></div>
        <div><label className="field-label">Correo</label>
          <input data-testid="registro-email" type="email" required className="input-field" value={form.email} onChange={set("email")} /></div>
        <div><label className="field-label">Contraseña (mínimo 8 caracteres)</label>
          <input data-testid="registro-password" type="password" minLength={8} required className="input-field" value={form.password} onChange={set("password")} /></div>
        <div><label className="field-label">Repite la contraseña</label>
          <input data-testid="registro-confirm" type="password" minLength={8} required className="input-field" value={form.confirm} onChange={set("confirm")} /></div>
        <button data-testid="registro-submit" type="submit" disabled={loading} className="btn-lilac w-full justify-center">
          {loading ? "Creando cuenta…" : "Crear mi cuenta ✦"}
        </button>
      </form>
      <p className="text-sm text-zinc-500 mt-6">
        ¿Ya tienes cuenta? <Link to="/ingresar" data-testid="registro-to-login" className="text-[#C9A25E] hover:underline">Entra aquí</Link>
      </p>
    </AuthShell>
  );
}
